export default __webpack_public_path__ + "static/media/M2.414076e9.svg";